import { CHECKLIST_ITEM_TYPE } from 'src/constants/tasksV2';

export default {
    id: 17,
    type: CHECKLIST_ITEM_TYPE.RECORD_ATTENDANCE,
    manifestKey: 'RECORD_ATTENDANCE',

    try_it: {
        button_label: 'Record Attendance',
        cell_component_import: {
            from: 'src/pages/dashboard/tables/AllLeadTable/TaskChecklistField',
            named: 'RecordAttendanceCell',
        },
        prefill: {
            completion_state: 'YES',
            response_payload: {},
        },
    },
    pre_flight_diff: [
        'Attendance confirmation triggers via separate appointment endpoint',
        'Lead status: CONSULTATION_BOOKED → CONSULTATION_ATTENDED',
        'Checklist item: PENDING → YES',
        'BE auto-stamps response_payload.appointment_already_attended based on appointment queryset',
        'TaskActivity row created with action CHECKLIST_ITEM_COMPLETED',
    ],
    has_step2_throttle: true,
    validation_laboratory: null,
};
